import * as React from "react";
import moment from "moment";

import { Radio, DatePicker, Input, Form } from "antd";
import { PageHero, Page } from "src/components/common";
import DropdownInputAnt from "src/components/forms/DropdownInputAnt";
import { useState, useEffect } from "react";

import fleetErrorAPI from "src/admin/Organization/OrganizationError/FleetErrorAPI";

import { Validation } from "src/common/utils";
import { Button } from "src/components/buttons";

interface IProps {
	fleetError: FleetErrorDTO;
	match?: any;
	history?: any;
	location?: any;
}

const FleetErrorsForm = (props: IProps) => {
	const initialfleetError: FleetErrorDTO = {
		id: undefined,
		description: "",
		errorCategory: undefined,
		errorCode: "",
		lastModified: undefined,
		maxAllowed: undefined,
		points: undefined,
		skillCategory: undefined,
		isActive: undefined,
	};

	const [fleetError, setFleetError] = useState(initialfleetError);

	const existingFleetErrors = props.location.state;

	useEffect(() => {
		let didCancel = false;
		const { fleetErrorId } = props.match.params;
		if (fleetErrorId !== "-1") {
			fleetErrorAPI.getFleetError({ fleetErrorId }).then((res) => {
				if (!didCancel) {
					setFleetError(res);
				}
			});
		}

		if (fleetError.lastModified === undefined) {
			const newFleetError = { ...fleetError };
			const newDate = moment();
			newFleetError.lastModified = newDate.toString();
			if (!didCancel) {
				setFleetError(newFleetError);
			}
		}

		return () => {
			didCancel = true;
		};
	}, []);

	const submitFleetError = () => {
		const newFleetError = { ...fleetError };
		const lastModified = moment().toString();
		newFleetError.lastModified = lastModified;
		newFleetError.organizationId = undefined;
		fleetErrorAPI
			.updateFleetError(newFleetError)
			.then(() => props.history.push(`/admin/fleet-errors`));
	};

	const onFleetErrorSkillChange = (value: any) => {
		const newFleetError = { ...fleetError };
		newFleetError.skillCategory = value.key;
		setFleetError(newFleetError);
	};

	const onFleetErrorErrorCategoryChange = (value: any) => {
		const newFleetError = {
			...fleetError,
			errorCategory: value.key,
		};
		setFleetError(newFleetError);
	};

	const onFleetErrorPointsChange = (value: any) => {
		const newFleetError = {
			...fleetError,
			points: value.key,
		};
		setFleetError(newFleetError);
	};

	const setFleetErrorProperties = (e: any) => {
		const newError = { ...fleetError, [e.target.name]: e.target.value };
		setFleetError(newError);
	};

	const onFleetErrorStatusChange = (e: any) => {
		if (e.target.type === "radio") {
			const newError = { ...fleetError, [e.target.name]: e.target.value };
			setFleetError(newError);
		}
	};

	const convertLastModified = (date: string) => {
		const newDate = moment.utc(date).local();
		return newDate;
	};

	const isValid = (validError: any) => {
		const validateValues: string[] = Object.keys(validError).map((key) => {
			if (key === "errorCodeAndSkillCategory") {
				return validError[key].skillCategory.isActive.validationStatus ===
					"success" &&
					validError[key].errorCode.isActive.validationStatus === "success"
					? "success"
					: "error";
			}
			return validError[key].validationStatus;
		});
		return Validation.isValid(validateValues);
	};

	const validFleetError = {
		isActive: Validation.validateIsActive(fleetError.isActive!),
		maxAllowed: Validation.validateIfANumberOrNumbers(fleetError.maxAllowed!),
		errorCategory: Validation.validateStringIsNotEmpty(
			fleetError.errorCategory!,
			"Please enter a category"
		),
		errorCode: Validation.validateErrorCode(fleetError.errorCode!),
		points: Validation.validateIfANumberOrNumbers(fleetError.points!),
		description: Validation.validateStringIsNotEmpty(
			fleetError.description!,
			"Please enter a description"
		),
	};

	return (
		<Page title="Edit fleet error">
			<PageHero
				title="Edit fleet error"
				parent="Fleet Errors"
				parentRoute="/admin/fleet-errors"
			/>
			<div className="container-fluid">
				<div className="row">
					<div className="col-3 form-group">
						<label>Skills category *</label>
						<Form.Item>
							<DropdownInputAnt
								value={fleetError.skillCategory}
								placeholder="Choose a skill category"
								name="SkillCategory"
								pickListCode="SkillCategory"
								onChange={onFleetErrorSkillChange}
							/>
						</Form.Item>
					</div>
					<div className="col-3 form-group">
						<label htmlFor="errorCode">Error code *</label>
						<Form.Item
							validateStatus={validFleetError.errorCode.validationStatus}
							help={validFleetError.errorCode.message}
							hasFeedback={true}
						>
							<Input
								defaultValue="A"
								id="errorCode"
								name="errorCode"
								onChange={setFleetErrorProperties}
								value={fleetError.errorCode}
								placeholder="Enter an Error code"
							/>
						</Form.Item>
					</div>
					<div className="col-3 form-group">
						<label>Active *</label>
						<Form.Item
							validateStatus={validFleetError.isActive.validationStatus}
							help={validFleetError.isActive.message}
							hasFeedback={true}
						>
							<Radio.Group
								defaultValue="a"
								onChange={(e: any) => onFleetErrorStatusChange(e)}
								name="isActive"
								value={fleetError.isActive}
							>
								{[
									{ label: "Active", value: true },
									{ label: "InActive", value: false },
								].map((item) => {
									return (
										<Radio key={item.label} value={item.value}>
											{item.label}
										</Radio>
									);
								})}
							</Radio.Group>
						</Form.Item>
					</div>
				</div>
				<div className="row">
					<div className="col-3 form-group">
						<label>Error category *</label>
						<Form.Item
							validateStatus={validFleetError.errorCategory.validationStatus}
							help={validFleetError.errorCategory.message}
							hasFeedback={true}
						>
							<Input
								id="ErrorCategory"
								name="ErrorCategory"
								onChange={onFleetErrorErrorCategoryChange}
								value={fleetError.errorCategory}
								placeholder="Choose a skill category"
							/>
						</Form.Item>
					</div>
					<div className="col-3 form-group">
						<label htmlFor="maxAllowed">Max allowed *</label>
						<Form.Item
							validateStatus={validFleetError.maxAllowed.validationStatus}
							help={validFleetError.maxAllowed.message}
							hasFeedback={true}
						>
							<Input
								defaultValue="2"
								id="maxAllowed"
								name="maxAllowed"
								value={fleetError.maxAllowed}
								placeholder="Enter in a maximum amount"
								onChange={setFleetErrorProperties}
							/>
						</Form.Item>
					</div>
					<div className="col-3 form-group">
						<label>Points *</label>
						<Form.Item
							validateStatus={validFleetError.points.validationStatus}
							help={validFleetError.points.message}
							hasFeedback={true}
						>
							<DropdownInputAnt
								value={fleetError.points}
								onChange={onFleetErrorPointsChange} // wire frames have pItem- code & description in dropdown
								placeholder="Choose a point"
								name="PointsCategory"
								pickListCode="PointCategory"
							/>
						</Form.Item>
					</div>
				</div>
				<div className="row">
					<div className="col-6 form-group">
						<label htmlFor="description">Description *</label>
						<Form.Item
							validateStatus={validFleetError.description.validationStatus}
							help={validFleetError.description.message}
							hasFeedback={true}
						>
							<Input.TextArea
								id="description"
								name="description"
								autosize={{ minRows: 5, maxRows: 10 }}
								value={fleetError.description}
								onChange={setFleetErrorProperties}
								placeholder="Enter in a description"
							/>
						</Form.Item>
					</div>
					<div className="col-3 form-group">
						<label>Last modified</label>
						<DatePicker
							format="MMM DD, YYYY"
							disabled={true}
							value={convertLastModified(fleetError.lastModified!)}
							placeholder="MMM DD, YYYY"
						/>
					</div>
				</div>
				<div className="row">
					<div className="col">
						<Button
							className="btn-primary"
							onClick={submitFleetError}
							disabled={!isValid(validFleetError)}
						>
							Save
						</Button>
					</div>
				</div>
			</div>
		</Page>
	);
};

export default FleetErrorsForm;
